import { render, staticRenderFns } from "./checkoutDetails.vue?vue&type=template&id=7010c9b6&"
import script from "./checkoutDetails.vue?vue&type=script&lang=js&"
export * from "./checkoutDetails.vue?vue&type=script&lang=js&"
import style0 from "./checkoutDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports